import moment from "moment";

const formatDate = (date, format) => {
  return date ? moment(date).format(format) : "";
};

export default formatDate;
